<template>
  <v-container justify-center fill-height fluid grid-list-xl>
    <v-layout justify-center wrap >  
       <v-avatar slot="offset" class="mx-auto d-block" size="90">
            <img :src="require('@/assets/kids.jpg')">
          </v-avatar>   
     <v-flex xs12 md12>  
      <material-card>
       <v-card-text class="text-xs-center">
        <v-container py-0>
          <v-layout wrap>
          <v-flex md12>
            <material-card color="green" title="" text="Kids Table">
              <v-card-title>Program I Coordinate</v-card-title>
              <v-data-table dense v-bind:headers="programHead" v-bind:items="programList" item-key="_id" class="caption" :loading="loading" hide-default-footer>
                <template v-slot:item.ProgramName="{item}">
                    <v-row>
                      <v-btn class="caption ma-0" @click=viewParticipantList(item.ProgramId) label dense small outlined color="blue">{{ item.ProgramName }}</v-btn>
                    </v-row>
                </template>
                <!-- <template v-slot:item.ApprovalStatus="{ item }">
                  <v-icon v-if="item.ApprovalStatus=='Submitted'" dark color="blue">mdi-cog-clockwise</v-icon>
                  <v-icon v-if="item.ApprovalStatus=='Approved'" dark color="green">mdi-thumb-up</v-icon>
                  <v-icon v-if="item.ApprovalStatus=='Rejected'" dark color="green">mdi-thumb-down</v-icon>
                  <v-icon v-if="item.ApprovalStatus=='NeedMoreInfo'" dark color="blue">mdi-car-info</v-icon>
                </template> -->
                <template v-slot:item.Update="{item}">
                    <v-row>
                      <v-btn v-if="item.ApprovalStatus==='Submitted' || item.ApprovalStatus==='Active' " class="ma-2" @click=updateProgram(item.ProgramId) icon color="purple" dark><v-icon dark>mdi-wrench</v-icon></v-btn>
                    </v-row>
                </template>
              </v-data-table>
            </material-card>
            <v-spacer></v-spacer>
            <v-flex xs12 text-xs-center>
                <v-btn dense small v-if="enableCoordinator==='True'" @click=ProgramDataCapture() color="success" dark>Coordinate a Program</v-btn>
            </v-flex>                          
          </v-flex>                       
          </v-layout>
        </v-container>
         </v-card-text>
      </material-card>
      <material-card>
       <v-card-text>
        <v-container py-0>
          <v-layout wrap>
          <v-flex md12>
            <material-card color="green" title="" text="Kids Table">
              <v-card-title>Enrolled Program</v-card-title>
              <v-data-table dense v-bind:headers="familyProgramHead" v-bind:items="familyProgramList" item-key="_id" class="caption" :loading="loading" hide-default-footer>
                <!-- <template v-slot:item.ApprovalStatus="{ item }">
                  <v-chip :color="getColor(item.ApprovalStatus)" class="overline" dark small></v-chip>
                </template> -->
                <template v-slot:item.Update="{item}">
                    <v-row>
                      <v-btn class="ma-0" @click=updateProgram(item.ProgramId) icon small color="orange darken-2"><v-icon>mdi-wrench</v-icon></v-btn>
                    </v-row>
                </template>
              </v-data-table>
            </material-card>
             <v-flex xs12 text-xs-center>
                  <v-btn v-if="enableParticipant==='True'" dense small class="mx-0 font-weight-light" @click=enrollProgramLoad() color="warning">Enroll</v-btn>
              </v-flex>           
          </v-flex>                       
          </v-layout>
        </v-container>
         </v-card-text>
      </material-card>
        </v-flex>
    </v-layout>
     <v-layout row justify-center>
       <v-dialog v-model="previewPopup"  max-width="500px" max-height="600px" hide-overlay>
        <v-toolbar color="light-blue lighten-2" height="65">
          <v-toolbar-title class="body-2">Program Review</v-toolbar-title>
        </v-toolbar>
         <v-card>
            <v-card-text class="text-xs-center">
          <v-container grid-list-md>
               <v-layout wrap>
              <v-flex xs12 sm6 md4><p class="font-weight-black">Program Name</p>{{enrollProgram.ProgramName}}</v-flex>
              <v-flex xs12 sm6 md4><p class="font-weight-black">Choreographer</p>{{enrollProgram.Choreographer}}</v-flex>
              <v-flex xs12 sm6 md4><p class="font-weight-black">Team Name</p>{{enrollProgram.TeamName}}</v-flex>              
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn small color="error" @click="closepreviewPopup()">cancel</v-btn>
              <v-btn small color="success" dark @click="completeRegistration()">confirm</v-btn> 
            </v-card-actions>
          </v-layout>
          </v-container>
         </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="participantPopup"  max-width="800px" hide-overlay>
        <v-toolbar color="light-blue lighten-2" height="65">
          <v-toolbar-title class="body-2">Participant Enrollment List</v-toolbar-title>
        </v-toolbar>
         <v-card>
          <v-card-text class="text-xs-center">
          <v-container grid-list-md>
           <v-data-table dense v-bind:headers="ParticipantHead" v-bind:items="participantList" item-key="_id" class="caption" :loading="loading" hide-default-footer>
             <template v-slot:item.Remove="{item}">
                    <v-row>
                      <v-btn class="ma-0" @click=deleteParticipant(item._id) icon small color="red darken-2"><v-icon>mdi-delete-alert</v-icon></v-btn>
                    </v-row>
                </template>
           </v-data-table>
          </v-container>
           <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn small color="error" @click="closeParticipantPopup">Close</v-btn> 
            </v-card-actions>
         </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="coordinate" max-width="800px" max-height="1000px" hide-overlay>
        <v-toolbar color="light-blue lighten-2" height="65">
          <v-toolbar-title class="body-2">Enroll as Program-Coordinator</v-toolbar-title>
        </v-toolbar>
        <v-form ref="form" v-model="valid" :close-on-content-click="false" :nudge-right="100" offset-y full-width>
          <v-card>
            <v-card-text>
                    <v-container grid-list-md>
                      <v-layout wrap>
                        <v-flex xs12 sm6 md4>
                            <v-autocomplete outlined dense placeholder=" " label="Event" cache-items hide-no-data v-model="Json.eventId" :items="eventList" item-value="_id"
                                  item-text="eventname" :disabled="Json._id != ''">
                            </v-autocomplete> 
                        </v-flex>
                        <v-flex xs12 sm6 md4>
                            <v-autocomplete outlined dense placeholder=" " label="Category" cache-items hide-no-data v-model="Json.category" :items="categoryList" :disabled="Json._id != ''" >
                                </v-autocomplete> 
                        </v-flex>
                        <v-flex xs12 sm6 md4>
                            <v-autocomplete outlined dense placeholder=" " label="Sub-Category"  cache-items hide-no-data v-model="Json.subcategory" :items="subcategoryList">
                            </v-autocomplete> 
                        </v-flex>
                         <v-flex xs12 sm6 md4>
                          <v-text-field  :rules="nameRules" class="body-2 mr-2" box v-model="Json.SystemProgramNumber" label="Program Number" placeholder=" " height="25" disabled></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm6 md4>
                          <v-text-field  :rules="nameRules" class="body-2 mr-2" box v-model="Json.ProgramName" label="Program Name" placeholder=" " height="25" ></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm6 md4>
                          <v-text-field  :rules="nameRules" class="body-2 mr-2" box v-model="Json.TeamName" label="Team Name" placeholder=" " height="25" ></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm6 md4>
                          <v-text-field :rules="nameRules" class="body-2 mr-2" box v-model="Json.Choreographer" label="Choreographer" placeholder=" " height="25" ></v-text-field>
                        </v-flex>
                         <v-flex xs12 sm6 md4>
                          <v-autocomplete outlined dense placeholder=" " class="body-2 mr-2" box v-model="Json.SpecialRequirement" label="Special Requirement" height="25" :items="['Yes', 'No']"></v-autocomplete>
                        </v-flex>
                        <v-flex xs12 sm6 md4>
                          <v-text-field :rules="nameRules" class="body-2 mr-2" box v-model="Json.ProgramDetails" label="Program Details" placeholder=" " height="25" ></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm6 md4>
                          <v-text-field :rules="nameRules" class="body-2 mr-2" box v-model="Json.TimeRequired" label="Time Required" placeholder=" " height="25" ></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm6 md4>
                          <v-text-field :rules="nameRules" class="body-2 mr-2" box v-model="Json.AudioTrackLocation" label="Upload audio track" placeholder=" " height="25" ></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm6 md4>
                          <v-autocomplete outlined dense placeholder=" " class="body-2 mr-2" box v-model="Json.NeedSetupTime" label="Need SetupTime?" height="25" :items="['Yes', 'No']"></v-autocomplete>
                        </v-flex>
                        <v-flex xs12 sm6 md4>
                          <v-text-field :rules="nameRules" class="body-2 mr-2" box v-model="Json.SetupDetails" label="Setup Details" placeholder=" " height="25" ></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm6 md4>
                          <v-text-field :rules="nameRules" class="body-2 mr-2" box v-model="Json.TeamAnnouncement" label="Team Announcement-OnStage" placeholder=" " height="25" ></v-text-field>
                        </v-flex> 
                         <v-flex xs12 sm6 md4>
                          <v-text-field :rules="nameRules" class="body-2 mr-2" box v-model="Json.Comments" label="Comments" placeholder=" " height="25" ></v-text-field>
                        </v-flex>                         
                      </v-layout>
                    </v-container>
              </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn small outline color="light-green lighten-3" @click="close">Close</v-btn>
              <v-btn  v-if="Json._id == ''" small outline color="light-green lighten-2" @click="coordinateProgram()" :disabled="!valid">Create</v-btn>
              <v-btn  v-if="Json._id !== ''" small outline color="light-green lighten-2" @click="updateProgramData()" :disabled="!valid">Update</v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-dialog>
      <v-dialog v-model="participate" max-width="600px"  hide-overlay>
        <v-toolbar color="light-green lighten-2" height="65">
          <v-toolbar-title class="body-2">Enroll to Program</v-toolbar-title>
        </v-toolbar>
        <v-form ref="form" v-model="valid" :close-on-content-click="false" :nudge-right="100" offset-y full-width>
          <v-card>
            <v-card-text>
                    <v-container grid-list-md>
                      <v-layout wrap>
                        <v-flex xs12 sm0 md6>
                          <v-autocomplete outlined dense placeholder=" " label="Select Family Member" return-object cache-items hide-no-data v-model="kid" :items="kidsList" item-value="_id"
                          item-text="firstname" ></v-autocomplete> 
                        </v-flex>                                            
                        <v-flex xs12 sm0 md5>
                          <v-text-field ref="participantData.ProgramId" :rules="nameRules" class="body-2 mr-2" box v-model="participantData.ProgramId" label="Program Number" placeholder=" " height="25" ></v-text-field>
                        </v-flex>                                                                      
                      </v-layout>
                    </v-container>
              </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn small outline color="light-green lighten-3" @click="close">Close</v-btn>
              <v-btn  v-if="participantData.ProgramId !== '' && kid!=''" small outline color="light-green lighten-2" @click="enrolle2Program()" :disabled="!valid">Enroll</v-btn>
              <v-btn  v-if="participantData.ProgramId === ''" small outline color="light-green lighten-3" @click="submit" :disabled="!valid">Fill All Data</v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-dialog>
      <v-dialog v-model="NotFound" persistent max-width="350">
        <v-card>
          <v-card-title class="headline">InCorrect Program Number</v-card-title>
          <v-card-text>Kindly dobule check your programID and use without any space !</v-card-text>
           <v-card-text>if you get the same Error, kindly reach out to support team "cltts@gmail.com"</v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer><v-btn color="primary" text flat @click="closePopup">Try Again</v-btn>
            </v-card-actions>
        </v-card>
      </v-dialog>        
    </v-layout>
  </v-container>
</template>
<script>
import ReportServices from '@/services/ReportServices'
export default {
  data: () => ({
      rOPen: null,
      email: undefined,
      form: false,
      isLoading: false,
      valid: true,
      coordinate: false,
      participate: false,
      popup: false,
      loggedInPerson:'',
      profiledata:'',
      kidPopup:false,
      programList:[],
      familyProgramList:[],
      categoryList:'',
      category:'',
      enrollProgram:{},
      subcategoryList:[],
      subcategory:'',  
      kidsList:[],
      kid:[],
      enableCoordinator:'',
      enableParticipant:'',
      NotFound:false,
      previewPopup:false,
      eventList:[],
      eventName:'',
      allMemberData:'',
      selectedCategory:'',      
      participantPopup:false,
      participantList:{},
      participantData:{
        ProgramId:'',
        familyId:'',
        kidsId:'',
        firstname:'',
        lastname:'',
        membershipcategory:'',
        coordianatorName:'',
        ProgramName:'',
        SystemProgramNumber:''
        },    
      member: {
        _id: '', 
        firstname: '',
        lastname: '',
        primaryemail: '',
        mobile: '',
        address: '',
        secondryphone: '',
        membershipcategory: '',
        paymentstatus: '',
        spousename: '',
        spouseemail: ''
      },
      Json:{
        _id:'',
        eventId:'',
        coordianatorId:'',
        coordianatorName:'',
        coordinatorEmail:'',
        category:'',
        subcategory:'',
        ProgramName: '',
        SpecialRequirement: '',
        ProgramDetails:'',
        TimeRequired:'',
        AudioTrackLocation:'',
        NeedSetupTime:'',
        SetupDetails:'',
        Choreographer:'',
        TeamName:'',
        TeamAnnouncement:'',
        SystemProgramNumber:'',
        ApprovalStatus:'Submitted',
        Comments:''
      },
     KidsJson: {        
        firstname: '',
        lastname: '',
        age: '',
        gender: '',
        familyId:''
      },
      rules: {
        email: v => (v || '').match(/@/) || 'Please enter a valid email',
        length: len => v => (v || '').length >= len || `Invalid character length, required ${len}`,
        password: v => (v || '').match(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*(_|[^\w])).+$/) || 'Password must contain an upper case letter, a numeric character, and a special character',
        required: v => !!v || 'This field is required',
      },
    programHead: [
      {sortable: false,text: 'Program Name', value: 'ProgramName'}, 
      {sortable: false, text: 'Team Name', value: 'TeamName'},    
      {sortable: false,text: 'Name',value: 'CoordianatorName'},     
      {sortable: false,text: 'Status', align: 'left', value: 'ApprovalStatus'},
      {sortable: false,text: 'Update',value: 'Update'},
    ],
     ParticipantHead: [
      {sortable: false,text: 'First Name', value: 'firstname'},     
      {sortable: false,text: 'Last Name',value: 'lastname'},
      {sortable: false,text: 'Remove', align: 'left',value: 'Remove'}
    ],
      familyProgramHead: [
      {sortable: false,text: 'Name', value: 'FirstName'},  
      {sortable: false,text: 'Program Name', value: 'ProgramName'},     
      {sortable: false, text: 'Team Name', value: 'TeamName'},
       {sortable: false,text: 'Coordinator Name',value: 'coordianatorName'},
      {sortable: false,text: 'Status', align: 'left', value: 'ApprovalStatus'}
    ],
  }),
   methods: {
     closepreviewPopup(){
       this.previewPopup=false 
     },
     deleteParticipant(id)
     {
      const conf=confirm('Are you sure you want to Remove?')
      if(conf===true)
        {
           ReportServices.deleteParticipant(id)
            setTimeout(() => {
              this.participantPopup=false
            this.refresh()
            }, 100)
        }
        else{
            this.participantPopup=false 
        }
     },
    async updateProgram(id){
       this.Json=(await ReportServices.getprogrambyid(id)).data
       this.coordinate= true
      },
     getColor (status) {
      if (status === 'Active') return 'green'
      else if (status === 'Pending') return 'cyan'
      else if (status === 'Cancel') return 'orange'
      else return 'blue'
    },
   async viewParticipantList (id) {
    this.participantList=(await ReportServices.getAllParticipantByProgramId(id)).data
     this.participantPopup = true
    },
    closeParticipantPopup () {
      this.participantPopup = false
    },
      close () {
      this.coordinate = false
      this.participate= false
      this.kidPopup = false
      setTimeout(() => {
        this.refresh() }, 100)
    },
    async ProgramDataCapture() {
    this.coordinate= true
    },
    async enrollProgramLoad() {
      this.participantData.ProgramId=''
      this.participate = true      
    },
    async addNewkid() {
      this.kidPopup = true      
    },
     async closePopup() {
      this.NotFound=false  
      this.participate=false   
    },
     async enrolle2Program() {   
      this.enrollProgram=(await ReportServices.getProgramBySPN(this.participantData.ProgramId)).data  
      //alert(JSON.stringify(this.enrollProgram))
      if( this.enrollProgram==='empty')
      {
        this.NotFound=true       
      }
      else{
      this.participantData.ProgramId=this.enrollProgram._id
      this.participantData.coordianatorName=this.enrollProgram.coordianatorName
      this.participantData.ProgramName=this.enrollProgram.ProgramName
      this.participantData.SystemProgramNumber=this.enrollProgram.SystemProgramNumber
      this.participate=false
      this.previewPopup=true      
        }     
    },
   
    async completeRegistration()
    {
      this.participantData.familyId=this.profiledata._id
      this.participantData.kidsId=this.kid._id
      this.participantData.firstname=this.kid.firstname
      this.participantData.lastname=this.kid.lastname
      this.participantData.membershipcategory=this.kid.membershipcategory  
      //alert(JSON.stringify(this.participantData))      
      await ReportServices.createParticipantData(this.participantData)
      setTimeout(() => { 
      this.participate = false
      this.previewPopup=false
      this.refresh()}, 200)
    },
    async coordinateProgram () {
      const ObjectId = (m = Math, d = Date, h = 16, s = s => m.floor(s).toString(h)) =>
          s(d.now() / 1000) + ' '.repeat(h).replace(/./g, () => s(m.random() * h))
      this.Json._id=ObjectId
      this.Json.coordianatorId=this.profiledata._id
      this.Json.coordianatorName=this.profiledata.firstname 
      this.Json.coordinatorEmail=this.profiledata.primaryemail
      this.Json.SystemProgramNumber='P'+Math.floor(100000 + Math.random() * 900000)
      if (this.$refs.form.validate()) {
         ReportServices.createProgram(this.Json)
         setTimeout(() => {
           this.coordinate= false
          this.refresh()}, 200)
      }
    },
    async updateProgramData () {
      if (this.$refs.form.validate()) {
        await ReportServices.updateProgram(this.Json)
        setTimeout(() => {
        this.coordinate= false
        this.refresh()}, 200)
      }
    },  
     async refresh () {
      this.loading = true
      this.categoryList=[]
      this.eventList=[]
      this.loggedInPerson = this.$store.getters.email
      this.profiledata = (await ReportServices.getmemberbyemailAddress(this.loggedInPerson)).data
      this.programList = (await ReportServices.programICoordinate(this.profiledata._id)).data 
      this.familyProgramList = (await ReportServices.programByFamilyID(this.profiledata._id)).data  
      this.kidsList = (await ReportServices.KidsByFamilyId(this.profiledata._id)).data
      var spouse = (await ReportServices.spouseByFamilyId(this.profiledata._id)).data 
      this.eventList=(await ReportServices.getactiveEvents()).data 
      //alert(JSON.stringify(this.eventList))            
      this.kidsList = this.kidsList.concat(spouse,this.profiledata)       
      this.eventList.map(x=> {
         if(x.category!=null && x.category!='')
              this.categoryList=this.categoryList.concat(x.category) 
          if(x.subcategory!=null && x.subcategory!='')
               this.subcategoryList=this.subcategoryList.concat(x.subcategory)  
           this.enableCoordinator=x.enableCoordinatorEnrollment
          this.enableParticipant=x.enableParticipantEnrollment
      });
     
     // alert(this.enableCoordinator)
     //alert(this.enableParticipant)
      this.loading = false
      this.noDataText = 'No data available'
    }
  },
  async mounted () {
    this.enrollStatus = (await ReportServices.getEnrollmentStatus()).data
    //this.rOPen = this.enrollStatus.IsOpen
  
    this.refresh()
  }
}
</script>
